import React from 'react';
import { HiLink } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import './ShortcutCard.css';


const ShortcutCard = (props) => {
    const { ind, label, link, valueOfLS } = props;

    const navigate = useNavigate()
    const handleClick = () => {
        window.location.href = link;
        localStorage.removeItem("active-menu");
    }
    return (
        <div onClick={handleClick} className={((ind % 2 && (ind < 4 || ind > 7)) || ((ind % 2) === 1 && (ind > 3 || ind < 8))) ? 'shortcut-card-second' : 'shortcut-card'}>
            <div className={'shortcut-icon-container  d-flex justify-content-center'}>
                <HiLink className={'shortcut-icon'} />
                
            </div>
            <p className={(ind % 2 && (ind < 4 || ind > 7)) || ((ind % 2) === 1 && (ind > 3 || ind < 8)) ? 'shortcut-text-second' : 'shortcut-text'}>{label}</p>
        </div>
    )
}

export default ShortcutCard
